import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ContentfulButton from '../Utilities/Buttons/ContentfulButton'

function PressCardV2({ data }) {
  const { headerImage, headerColor, description, linkUrl, linkAsset, newDate, button, isKit } = data
  if (isKit) {
    return (
      <div className="press-kit__logo-box">
        <div className="press-kit__photo-box">
          <GatsbyImage image={getImage(headerImage.image)} alt={headerImage.altText} />
        </div>
        <ContentfulButton data={button} oldPimary />
      </div>
    )
  }

  const dateToFormat = new Date(newDate)

  const formattedDate = `${dateToFormat.toLocaleString('en-us', {
    month: 'long'
  })} ${`0${dateToFormat.getDate()}`.slice(-2)}, ${dateToFormat.getFullYear()}`

  const link = linkAsset?.file?.url || linkUrl

  return (
    <a className="news__card" key={link} href={link} target="_blank" rel="noopener noreferrer">
      <div className="news__card-heading" style={{ backgroundColor: `${headerColor}` }}>
        <GatsbyImage
          image={getImage(headerImage.image)}
          alt={headerImage.altText}
          style={{ 'max-height': '54px', 'max-width': '210px' }}
        />
      </div>

      <div className="news__card-details">
        <p>{description?.description}</p>
        <p>
          <strong>{formattedDate}</strong>
        </p>
      </div>
    </a>
  )
}
PressCardV2.propTypes = {
  data: PropTypes.object.isRequired
}

export default PressCardV2
